import Chip from "@mui/material/Chip";
import { PricebookPeriodStatus } from "../../../../types/price-book.type";
import { PERIOD_STATUS_COLOR, PERIOD_STATUS_LABEL } from "./periodModel";

interface PeriodStatusChipProps {
  status: PricebookPeriodStatus;
}

/** ใกล้หมด / กำลังใช้ / ล่วงหน้า / หมดแล้ว, coloured by how soon it needs attention. */
export default function PeriodStatusChip({ status }: PeriodStatusChipProps) {
  return (
    <Chip
      size="small"
      color={PERIOD_STATUS_COLOR[status]}
      variant={status === "expired" ? "outlined" : "filled"}
      label={PERIOD_STATUS_LABEL[status]}
    />
  );
}
